import Reveal, { Overline } from "@/components/Reveal";

const OUTCOMES = [
  {
    n: "01",
    tag: "Articulation",
    title: "Clarity",
    body: "Every word lands. You speak with crisp articulation and deliberate structure, so your message is understood the first time — in the boardroom, the courtroom, and on the investor call.",
  },
  {
    n: "02",
    tag: "Authority",
    title: "Credibility",
    body: "You sound the way your record reads. A steady, well-supported voice signals composure and authority before your content is even considered — without force, and without strain.",
  },
  {
    n: "03",
    tag: "Endurance",
    title: "Vocal Stamina",
    body: "Your voice holds as long as the day does. Speak through back-to-back meetings, roadshows, and long trials with a voice built for sustainable, professional use.",
  },
];

export default function Outcomes() {
  return (
    <section data-testid="outcomes-section" className="bg-[#E3D9C8] py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <Overline>What Changes</Overline>
          <h2 className="mt-6 font-serif text-3xl leading-[1.2] tracking-tight text-[#26282E] sm:text-4xl lg:text-[2.75rem]">
            Three outcomes. Every engagement.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5B5E66] sm:text-lg">
            Executive communication coaching at Credible Presence is measured in business terms. Vocal mechanics
            are the method — these are the results.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3 lg:gap-8">
          {OUTCOMES.map((o, i) => (
            <Reveal key={o.n} delay={i * 0.12} className="h-full">
              <article
                data-testid={`outcome-card-${o.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="card-shadow group flex h-full flex-col rounded-md bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_14px_44px_rgba(38,40,46,0.12)] sm:p-10"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-serif text-4xl font-semibold text-[#2F5D8C]">{o.n}</span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8A8D94]">{o.tag}</span>
                </div>
                <h3 className="mt-8 font-serif text-2xl text-[#26282E]">{o.title}</h3>
                <p className="mt-4 text-[15px] leading-relaxed text-[#5B5E66]">{o.body}</p>
                <div className="mt-auto pt-8">
                  <div className="accent-rule w-12 transition-all duration-500 group-hover:w-full" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
